import { render, staticRenderFns } from "./symbol-progress-bar-v2.component.vue?vue&type=template&id=5345e670"
import script from "./symbol-progress-bar-v2.component.vue?vue&type=script&lang=js"
export * from "./symbol-progress-bar-v2.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports